import React from 'react';
import RabenLogo from 'src/images/raben-logo-removebg.png';
import { Box, Divider } from '@mui/material';
import { LogosContainer } from 'src/views/Pages/RegisterRaben/components/Header/index.styles';
import Logo from 'src/views/components/Logo';
import { Link } from 'react-router-dom';

export default function LogoWithRabenRed() {
  return (
    <LogosContainer sx={{ mb: '0px', height: '80px' }}>
      <Box sx={{ mt: '12px' }}>
        <Link to="/">
          <Logo width={195} height={52} />
        </Link>
      </Box>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ ml: '40px', mr: '8px', borderRightWidth: '2px' }}
      />
      <img src={RabenLogo} width="266px" height="120px" />
    </LogosContainer>
  );
}
